import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSidebarLayers } from '@/features/layout/hooks/useSidebarLayers'

export const useSetProfileSidebar = () => {
  const { setLayers } = useSidebarLayers()

  const { t } = useTranslation()

  useEffect(() => {
    setLayers([
      {
        name: t('userProfile.myProfile'),
        url: '', // no need to set url for profile, since there is one item.
        slug: 'profile',
        icon_id: 'UserBoldStroke',
      },
    ])
  }, [setLayers, t])
}
